import { render, staticRenderFns } from "./CorporateTargetsModal.vue?vue&type=template&id=caddc5ca"
import script from "./CorporateTargetsModal.vue?vue&type=script&lang=js"
export * from "./CorporateTargetsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports